var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBpArrowCollapseBpLightGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow-collapse",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "#99CC00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.538574,17.661621H2.461426c-.441895,0-.799805.35791-.799805.799805s.35791.799805.799805.799805h10.277344v10.277344c0,.441895.35791.799805.799805.799805s.799805-.35791.799805-.799805v-11.077148c0-.441895-.35791-.799805-.799805-.799805Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.538574,12.73877h-10.277344V2.461426c0-.441895-.35791-.799805-.799805-.799805s-.799805.35791-.799805.799805v11.077148c0,.441895.35791.799805.799805.799805h11.077148c.441895,0,.799805-.35791.799805-.799805s-.35791-.799805-.799805-.799805Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpArrowCollapseBpLightGreen);
export default __webpack_public_path__ + "static/media/bp-arrow-collapse-bp-light-green.37f8128ba91c3f1a2f273d78cc96c10a.svg";
export { ForwardRef as ReactComponent };